import styled from "styled-components";

import { colors } from "const/colors";
import { Article, Section, Text } from "styles";

import AtmosphereImage from "../AtmosphereImage/AtmosphereImage";
import FeatureRow from "../FeatureRow/FeatureRow";
import StoreBadges from "../StoreBadges/StoreBadges";

const Actions = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	align-items: center;
	gap: 20px;
	margin-top: 32px;
	width: 100%;
	min-width: 0;

	@media (max-width: 600px) {
		grid-template-columns: 1fr;
	}
`;

const BadgeSlot = styled.div`
	min-width: 0;

	> div {
		flex-wrap: nowrap;
	}
`;

export default function Hero() {
	return (
		<Section>
			<FeatureRow phone imageUrl="/assets/screens/hero.png" mediaAlt="Wishbox transactions for October">
				<Article>
					<Text extreme>
						<Text color={colors.blue}>Wishbox</Text> will help you{" "}
						<Text color={colors.orange}>record</Text> <Text color={colors.magenta}>expenses</Text>{" "}
						and <Text color={colors.green}>savings</Text>.
					</Text>
					<Text lede style={{ display: "block", marginTop: 28, maxWidth: 640 }}>
						Record expenses and savings with ease. <Text color={colors.green}>Collaborate</Text>{" "}
						with your family and friends. <Text color={colors.orange}>Talk to AI</Text> with a tap.
					</Text>
					<Text lede style={{ display: "block", marginTop: 28, maxWidth: 640 }}>
						Create a <Text color={colors.blue}>wishbox</Text> for a wish or a coming{" "}
						<Text color={colors.magenta}>expense</Text>, then <Text color={colors.green}>save</Text>{" "}
						from your wallet, bank, or drawer — on iPhone, iPad, Mac, and Apple Watch. Android
						and Wear OS are coming soon with the same app.
					</Text>
					<Actions>
						<BadgeSlot>
							<StoreBadges />
						</BadgeSlot>
						<AtmosphereImage />
					</Actions>
				</Article>
			</FeatureRow>
		</Section>
	);
}
